var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-10" },
    [
      _c(
        "div",
        { staticClass: "bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6" },
        [
          _c("div", { staticClass: "md:grid md:grid-cols-3 md:gap-6" }, [
            _c(
              "div",
              { staticClass: "md:col-span-1" },
              [
                _c(
                  "h3",
                  {
                    staticClass: "text-lg font-medium leading-6 text-gray-900"
                  },
                  [_vm._v(" Chat Widget ")]
                ),
                _c(
                  "p",
                  { staticClass: "mt-1 text-sm leading-5 text-gray-500" },
                  [
                    _vm._v(
                      " Having more than one Whatsapp number? Our widget support multiple whatsapp numbers. "
                    )
                  ]
                ),
                _c("WidgetPreview", { attrs: { config: _vm.config } })
              ],
              1
            ),
            _c("div", { staticClass: "md:col-span-2" }, [
              _c("fieldset", { staticClass: "mt-6" }, [
                _c(
                  "legend",
                  {
                    staticClass: "text-base leading-6 font-medium text-gray-900"
                  },
                  [_vm._v(" Enable Widget ")]
                ),
                _c(
                  "div",
                  { staticClass: "mt-4 flex flex-wrap" },
                  [
                    _c("VSwitch", {
                      model: {
                        value: _vm.config.widget.isEnabled,
                        callback: function($$v) {
                          _vm.$set(_vm.config.widget, "isEnabled", $$v)
                        },
                        expression: "config.widget.isEnabled"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("fieldset", { staticClass: "mt-6" }, [
                _c(
                  "legend",
                  {
                    staticClass: "text-base leading-6 font-medium text-gray-900"
                  },
                  [_vm._v(" Name and Phone Numbers ")]
                ),
                _c("div", { staticClass: "mt-4 " }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
                    },
                    [
                      _c(
                        "table",
                        { staticClass: "min-w-full divide-y divide-gray-200" },
                        [
                          _vm._m(0),
                          _c(
                            "tbody",
                            _vm._l(_vm.config.additionalAgents, function(
                              number,
                              index
                            ) {
                              return _c(
                                "tr",
                                { key: index, staticClass: "bg-white" },
                                [
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "px-2 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                                    },
                                    [_vm._v(" " + _vm._s(number.name) + " ")]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "px-2 py-4 whitespace-nowrap text-sm text-gray-500"
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(number.description) + " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "px-2 py-4 whitespace-nowrap text-sm text-gray-500"
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(number.phoneNumber) + " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "px-2 py-4 whitespace-nowrap text-right text-sm font-medium"
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-indigo-600 hover:text-indigo-900 mx-2",
                                          on: {
                                            click: function($event) {
                                              return _vm.editNumber(
                                                number,
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Edit")]
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-indigo-600 hover:text-indigo-900",
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteNumber(index)
                                            }
                                          }
                                        },
                                        [_vm._v("Delete")]
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      )
                    ]
                  )
                ])
              ]),
              _vm.showAddNumberForm === false
                ? _c("div", { staticClass: "mt-2" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                        on: { click: _vm.openNewNumberModal }
                      },
                      [_vm._v(" Add Another number ")]
                    )
                  ])
                : _vm._e(),
              _c("div", { staticClass: "mt-8" }, [
                _c("div", { staticClass: "rounded-md" }, [
                  _c("div", { staticClass: "grid grid-cols-6 gap-6" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-span-6 sm:col-span-6 lg:col-span-2 relative"
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass:
                              "block text-sm font-medium leading-5 text-gray-700",
                            attrs: { for: "city" }
                          },
                          [_vm._v("Header Color")]
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.config.colors.widgetHeaderColor,
                              expression: "config.colors.widgetHeaderColor"
                            }
                          ],
                          staticClass:
                            "mt-1 form-input block w-full py-2 px-12 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                          domProps: {
                            value: _vm.config.colors.widgetHeaderColor
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.config.colors,
                                "widgetHeaderColor",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _c("verte", {
                          staticClass: "colorPicker",
                          attrs: { picker: "square", model: "hex" },
                          model: {
                            value: _vm.config.colors.widgetHeaderColor,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.config.colors,
                                "widgetHeaderColor",
                                $$v
                              )
                            },
                            expression: "config.colors.widgetHeaderColor"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-span-6 sm:col-span-6 lg:col-span-2 relative"
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass:
                              "block text-sm font-medium leading-5 text-gray-700",
                            attrs: { for: "city" }
                          },
                          [_vm._v("Header Text Color")]
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.config.colors.widgetHeaderTextColor,
                              expression: "config.colors.widgetHeaderTextColor"
                            }
                          ],
                          staticClass:
                            "mt-1 form-input block w-full py-2 px-12 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                          domProps: {
                            value: _vm.config.colors.widgetHeaderTextColor
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.config.colors,
                                "widgetHeaderTextColor",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _c("verte", {
                          staticClass: "colorPicker",
                          attrs: { picker: "square", model: "hex" },
                          model: {
                            value: _vm.config.colors.widgetHeaderTextColor,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.config.colors,
                                "widgetHeaderTextColor",
                                $$v
                              )
                            },
                            expression: "config.colors.widgetHeaderTextColor"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _c("div", { staticClass: "mt-6" }, [
                  _c("div", {}, [
                    _c("div", { staticClass: "grid grid-cols-1 gap-6" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-span-12 sm:col-span-6 lg:col-span-2 relative"
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass:
                                "block text-sm font-medium leading-5 text-gray-700",
                              attrs: { for: "city" }
                            },
                            [_vm._v("Header title")]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.config.texts.widgetTitle,
                                expression: "config.texts.widgetTitle"
                              }
                            ],
                            staticClass:
                              "mt-1 form-input block w-full py-2 px-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                            domProps: { value: _vm.config.texts.widgetTitle },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.config.texts,
                                  "widgetTitle",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm.hasMoreTitleCharacters
                            ? _c(
                                "p",
                                {
                                  staticClass: "mt-2 text-sm text-red-600",
                                  attrs: { id: "email-error" }
                                },
                                [
                                  _vm._v(
                                    " Widget title should be less than 20 characters "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ]),
                    _c("div", { staticClass: "grid grid-cols-1 gap-6 mt-4" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-span-12 sm:col-span-6 lg:col-span-2 relative"
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass:
                                "block text-sm font-medium leading-5 text-gray-700",
                              attrs: { for: "city" }
                            },
                            [_vm._v("Header description")]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.config.texts.widgetDescription,
                                expression: "config.texts.widgetDescription"
                              }
                            ],
                            staticClass:
                              "mt-1 form-input block w-full py-2 px-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                            domProps: {
                              value: _vm.config.texts.widgetDescription
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.config.texts,
                                  "widgetDescription",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm.hasMoreDescriptionCharacters
                            ? _c(
                                "p",
                                {
                                  staticClass: "mt-2 text-sm text-red-600",
                                  attrs: { id: "email-error" }
                                },
                                [
                                  _vm._v(
                                    " Widget Description should be less than 70 characters "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ])
                  ])
                ])
              ]),
              _c("div", { staticClass: "mt-8 border-t border-gray-200 pt-5" }, [
                _c("div", { staticClass: "flex justify-end" }, [
                  _c(
                    "span",
                    { staticClass: "ml-3 inline-flex rounded-md shadow-sm" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "Polaris-Button Polaris-Button--primary",
                          attrs: { type: "submit" },
                          on: { click: _vm.update }
                        },
                        [_vm._m(1)]
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        ]
      ),
      _vm.showAddNumberForm
        ? _c("AddNewNumberModal", {
            attrs: { agent: _vm.currentNumberToEdit },
            on: {
              close: _vm.closeModal,
              create: _vm.addNewNumber,
              update: _vm.updateNumber
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "bg-gray-50" }, [
      _c("tr", [
        _c(
          "th",
          {
            staticClass:
              "px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
            attrs: { scope: "col" }
          },
          [_vm._v(" Name ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
            attrs: { scope: "col" }
          },
          [_vm._v(" Role ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
            attrs: { scope: "col" }
          },
          [_vm._v(" Phone Number ")]
        ),
        _c("th", { staticClass: "relative px-2 py-3", attrs: { scope: "col" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "Polaris-Button__Content" }, [
      _c("span", { staticClass: "Polaris-Button__Text" }, [_vm._v("Save")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }